type Props = { size?: number };

export function OtterMark({ size = 26 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-label="OTTER"
      style={{ display: 'block', flexShrink: 0, overflow: 'visible' }}
    >
      <rect x="0" y="0" width="32" height="32" rx="7" fill="var(--accent)" />
      <ellipse cx="8.5" cy="11" rx="1.7" ry="2.1" fill="var(--accent-ink)" transform="rotate(-15 8.5 11)" />
      <ellipse cx="23.5" cy="11" rx="1.7" ry="2.1" fill="var(--accent-ink)" transform="rotate(15 23.5 11)" />
      <path
        d="M 16 7 C 22 7 26 11 26 17 C 26 23 22 27 16 27 C 10 27 6 23 6 17 C 6 11 10 7 16 7 Z"
        fill="var(--accent-ink)"
      />
      <circle cx="11.8" cy="21.5" r="3.6" fill="var(--accent)" />
      <circle cx="20.2" cy="21.5" r="3.6" fill="var(--accent)" />
      <path
        d="M 14.2 17.2 Q 16 16 17.8 17.2 Q 17.8 19 16 20.2 Q 14.2 19 14.2 17.2 Z"
        fill="var(--accent-ink)"
      />
      <circle cx="11.5" cy="14" r="1.35" fill="var(--accent)" />
      <circle cx="20.5" cy="14" r="1.35" fill="var(--accent)" />
      <circle cx="11.9" cy="13.6" r="0.42" fill="var(--accent-ink)" />
      <circle cx="20.9" cy="13.6" r="0.42" fill="var(--accent-ink)" />
      <path
        d="M 14.5 22 Q 16 23.4 17.5 22"
        stroke="var(--accent-ink)"
        strokeWidth="1"
        fill="none"
        strokeLinecap="round"
      />
      <line x1="5" y1="20" x2="8.5" y2="20.5" stroke="var(--accent-ink)" strokeWidth="0.6" strokeLinecap="round" opacity="0.8" />
      <line x1="5" y1="22.5" x2="8.5" y2="22" stroke="var(--accent-ink)" strokeWidth="0.6" strokeLinecap="round" opacity="0.8" />
      <line x1="27" y1="20" x2="23.5" y2="20.5" stroke="var(--accent-ink)" strokeWidth="0.6" strokeLinecap="round" opacity="0.8" />
      <line x1="27" y1="22.5" x2="23.5" y2="22" stroke="var(--accent-ink)" strokeWidth="0.6" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
}
